import api from "./api";

// Capa de servicios API del dominio "system" (actualizaciones / versión / changelog)
// (FSD / capa API transversal). Wrappers de transporte finos.

export const getSystemVersionInfo = () => api.get("/system/version-info");
export const checkSystemUpdates = () => api.get("/system/check-updates");
export const getSystemUpdateStatus = () => api.get("/system/update-status");
export const getSystemChangelog = () => api.get("/system/changelog");
export const updateGithubToken = (payload) =>
  api.post("/system/update-github-token", payload);
export const performFullUpdate = (payload) =>
  api.post("/system/perform-full-update", payload);
